import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import warning from "../../assets/icons/warning.png";
import {
  BrowserView,
  MobileView,
} from "react-device-detect";
import "react-datepicker/dist/react-datepicker.css";
class TutorSignupModal extends React.PureComponent {
  constructor(props){
    super(props);
    this.state = { 
      firstName:"",
      lastName:"",
      DOB:"",
      email:"",
      password:"",
      errors : {
        firstName:"",
        lastName:"",
        DOB:"",
        password: "",
        email: ""
      },
      dateFocus:false
    }
  }

  handleInputChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSignUp = (signUpUser,setFormValues) => {
    this.validate();
    const errors = this.state.errors;
    if(errors.firstName === "" && errors.lastName === "" && errors.DOB === "" && errors.email === "" && errors.password === ""){
      const { firstName,lastName,DOB,email,password } = this.state;
      setFormValues(firstName,lastName,DOB,email,password);
      signUpUser();
    }
  }

  validate = () => {

    let errors = {
      firstName:"",
      lastName:"",
      DOB:"",
      password: '',
      email: ''
    }

    const emailRegExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if( this.state.firstName === "" ){
      errors.firstName = 'First name is required';
    }
    
    if( this.state.lastName === "" ){
      errors.lastName = 'Last name is required';
    }

    if( this.state.DOB === "" ){
      errors.DOB = 'Date of birth is required';
    }
    else {
      let givenDate = new Date();
      let birthDate =  new Date(this.state.DOB);
      let years = (givenDate.getFullYear() - birthDate.getFullYear());

      if (givenDate.getMonth() < birthDate.getMonth() || (givenDate.getMonth() === birthDate.getMonth() && givenDate.getDate() < birthDate.getDate())) {
        years--;
      }

      if (years >= 18) {
        errors.DOB = "";
      } else {
        errors.DOB = "You need to be at least 18. Other users of won't see your date of birth.";
      }
    }

    if( this.state.email === "" ){
      errors.email = 'Email is required';
    }
    else if( !this.state.email.match(emailRegExp) ){
      errors.email = 'Email is invalid';
    }
    
    if( this.state.password === "" ){
      errors.password = 'Password is required';
    }
    else if( this.state.password.length < 6 ){
      errors.password = 'Password must contain more than 6 characters';
    }

    this.setState({errors:errors})

  }

  handleFocus = (field) => {

    let errors = {
      firstName:"",
      lastName:"",
      DOB:"",
      password: '',
      email: ''
    }

    if(field === "firstName"){
      errors = {
        firstName: "",
        lastName: this.state.errors.lastName,
        DOB: this.state.errors.DOB,
        email: this.state.errors.email,
        password: this.state.errors.password
      }
      this.setState({errors:errors});
    }
    else if(field === "lastName"){
      errors = {
        firstName: this.state.errors.firstName,
        lastName: "",
        DOB: this.state.errors.DOB,
        email: this.state.errors.email,
        password: this.state.errors.password
      }
      this.setState({errors:errors});
    }
    else if(field === "DOB"){
      errors = {
        firstName: this.state.errors.firstName,
        lastName: this.state.errors.lastName,
        DOB: "",
        email: this.state.errors.email,
        password: this.state.errors.password
      }
      this.setState({errors:errors});
    }
    else if(field === "email"){
      errors = {
        firstName: this.state.errors.firstName,
        lastName: this.state.errors.lastName,
        DOB: this.state.errors.DOB,
        email: "",
        password: this.state.errors.password
      }
      this.setState({errors:errors});
    }
    else if(field === "password"){
      errors = {
        firstName: this.state.errors.firstName,
        lastName: this.state.errors.lastName,
        DOB: this.state.errors.DOB,
        email: this.state.errors.email,
        password: ""
      }
      this.setState({errors:errors});
    }
  }

  onClose = (onclose) => {
    const errors = {
      firstName:"",
      lastName:"",
      DOB:"",
      password: "",
      email: ""  
    }
    this.setState({
      firstName:"",
      lastName:"",
      DOB:"",
      email:"",
      password:"",
      errors : errors
    });
    onclose();
  }

  render() {
    const {
      tutorOpenModal,
      onclose,
      setFormValues,
      signUpUser,
      openSignInModal,
      onChangeReciveEmails,
      loading,
    } = this.props;

    let warningEmail,warningPassword,warningFirstName,warningLastName,warningDob;

    if(this.state.errors.firstName !== ""){
      warningFirstName = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    if(this.state.errors.lastName !== ""){
      warningLastName = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    if(this.state.errors.DOB !== ""){
      warningDob = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    if(this.state.errors.email !== ""){
      warningEmail = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    if(this.state.errors.password !== ""){
      warningPassword = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    return (
      <Modal
          size="lg"
          centered
          className="signUp-tutor-modal"
          show={tutorOpenModal}
          onHide={() => this.onClose(onclose)}
          >

          <div className="text-center"
            style={{
              width:"100%",
              borderBottom:"0.3px solid lightgray",
              margin:"0px",
              paddingTop:"20px",
              paddingBottom:"20px",
            }}
          >
            <span 
              style={{
                width:"100%",
                fontFamily: "CircularStdMedium, Arial, sans-serif",
                fontSize:"16px",
                fontWeight:"bold",
                color:"black",
                textAlign:"center",
                fontStretch: "normal",
                fontStyle: "normal",
                letterSpacing: "normal",
              }}
              >
              Sign up as a tutor
            </span>
          </div>
          <button
            onClick={() => this.onClose(onclose)}
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            style={{
              position: "absolute",
              zIndex: "9999",
              top:"15px",
              right:"50px",  
              width:"30px",
              height:"32px",
              paddingBottom:"15px",
              border:"none",
              backgroundColor:"white"
            }}
          >
            <span 
              aria-hidden="true" 
              style={{
                fontWeight:"bold",
                fontStrech:"normal",
                fontSize:"20px",
                color:"black",
                lineHeight:"normal",
                backgroundColor:"white"
              }}
              >
                x
            </span>
          </button>

          <Modal.Body style={{padding:"30px",marginBottom:"-25px"}}>
            <div className="container">
              <div className="row">
                <div className="col">

                  <div className="form">

                    <div className="floating-label">      
                      <input 
                        id="firstName"
                        name="firstName" 
                        type="text" 
                        placeholder="First name"
                        className={this.state.errors.firstName ? 'errorInput' : null}
                        value={this.state.firstName}
                        onChange={(e) => {
                          this.handleInputChange(e);
                        }}
                        onFocus={()=>this.handleFocus("firstName")}
                        onBlur={e => {
                        }}
                      />
                      <label className={this.state.errors.firstName ? 'label' : null}>
                        First name
                      </label>
                    </div>
                    <div className="error">{warningFirstName}{this.state.errors.firstName}</div>

                    <div className="floating-label">      
                      <input 
                        id="lastName"
                        name="lastName"
                        type="text"
                        placeholder="Last name"  
                        className={this.state.errors.lastName ? 'errorInput' : null}
                        value={this.state.lastName} 
                        onChange={(e) => {
                          this.handleInputChange(e);
                        }}
                        onFocus={()=>this.handleFocus("lastName")}
                        onBlur={e => {
                        }}
                      />
                      <label className={this.state.errors.lastName ? 'label' : null}>
                        Last name
                      </label>
                    </div>
                    <div className="error">{warningLastName}{this.state.errors.lastName}</div>

                    <BrowserView>

                      <div className="floating-label">      
                        <input 
                          id="DOB"
                          name="DOB"
                          type="text"
                          placeholder="Date of birth"  
                          style={{paddingRight:"10px"}}
                          className={this.state.errors.DOB ? 'errorInput' : null}
                          value={this.state.DOB}
                          onChange={(e) => {
                            this.handleInputChange(e);
                          }}
                          onFocus={(e) => { 
                            e.target.type="date"
                            this.handleFocus("DOB")
                          }}
                          onBlur={(e) => {
                            if(e.target.value===""){
                              e.target.type="text" 
                            }
                          }}
                        />
                        <label className={this.state.errors.DOB ? 'label' : null}>
                          Date of birth
                        </label>
                      </div>
                      <div className="error">{warningDob}{this.state.errors.DOB}</div>

                    </BrowserView>

                    <MobileView>

                      <div 
                        tabIndex={1} 
                        className={this.state.dateFocus ? 'dateFocus' : 'date'}
                        style={{
                          backgroundColor: this.state.errors.DOB ? "#fff1f1" : "",
                          border:  this.state.errors.DOB ? "solid 1px #fa4a4a" : ""
                        }}
                      >                     
                        <label className={this.state.errors.DOB ? 'label' : null}>
                          Date of birth
                        </label>  
                        <input 
                          id="DOB"
                          name="DOB"
                          type="date" 
                          value={this.state.DOB}
                          style={{
                            margin:"0px",
                            display:"block",
                            minWidth:"96%",
                            border:"none",
                            backgroundColor:"transparent"
                          }}
                          onChange={(e) => {
                            this.handleInputChange(e);
                          }}
                          onFocus={(e) => { 
                            this.handleFocus("DOB")
                            this.setState({dateFocus:true})
                          }}
                          onBlur={(e) => {
                            this.setState({dateFocus:false})
                          }}
                        />
                      </div>
                      <div className="error">{warningDob}{this.state.errors.DOB}</div>

                    </MobileView>

                    <div className="floating-label">      
                      <input 
                        id="email"
                        name="email" 
                        type="email" 
                        placeholder="Email"
                        className={this.state.errors.email ? 'errorInput' : null}
                        value={this.state.email}
                        onChange={(e) => {
                          this.handleInputChange(e);
                        }}
                        onFocus={()=>this.handleFocus("email")}
                        onBlur={e => {
                        }}
                      />
                      <label className={this.state.errors.email ? 'label' : null}>
                        Email
                      </label>
                    </div>
                    <div className="error">{warningEmail}{this.state.errors.email}</div>

                    <div className="floating-label">      
                      <input 
                        id="password"
                        name="password"
                        type="password"
                        placeholder="Password"  
                        className={this.state.errors.password ? 'errorInput' : null}
                        value={this.state.password} 
                        onChange={(e) => {
                          this.handleInputChange(e);
                        }}
                        onFocus={()=>this.handleFocus("password")}
                        onBlur={e => {
                        }}
                      />
                      <label className={this.state.errors.password ? 'label' : null}>
                        Password
                      </label>
                    </div>
                    <div className="error">{warningPassword}{this.state.errors.password}</div>

                  </div>                

                  <div>
                      <p 
                      style={{
                      width: "100%",
                      fontFamily: "OpenSans, Arial, sans-serif",
                      fontSize: "12.5px",
                      fontWeight: "normal",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "1.67",
                      letterSpacing: "normal",
                      textAlign: "left",
                      color: "#535252",
                      marginTop:"-10px"
                      }}
                      >
                      Will send you members-only deals, inspiration, offers, promotion, policy updates via email.
                      </p>
                  </div>

                  <div className="checkBoxContainer">
                    <label className="container">
                      I don’t want to receive marketing messages from Askademia. I can also opt out of 
                      receiving these at any time in my account settings or via the link in the message.
                      <input type="checkbox" onChange={onChangeReciveEmails} />
                      <span className="checkmark"></span>
                    </label>
                  </div>
      
                  <div>
                      <p 
                      style={{
                      width: "100%",
                      fontFamily: "OpenSans, Arial, sans-serif",
                      fontSize: "12.5px",
                      fontWeight: "normal",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "1.67",
                      letterSpacing: "normal",
                      textAlign: "left",
                      color: "#535252",
                      marginBottom:"15px"
                      }}
                      >
                      By selecting Sign up below, I agree to Askademia's <button
                      type="button"
                      style={{
                      fontWeight: "600",
                      color: "#007ab5",
                      textDecoration: "underline",
                      border:"none",
                      backgroundColor:"white",
                      padding:"0px"
                      }}
                      href="#">Terms and Conditions.</button>
                      </p>
                  </div>
                  
                  <button
                    type="button"
                    className="btn-lg-block login-btn mb-3" 
                    onClick={ () => this.handleSignUp(signUpUser,setFormValues)}
                    style={{ 
                      height: "57px",
                      padding: "18px",
                      fontFamily: "CircularStdMedium, Arial, sans-serif",
                      fontSize: "16px",
                      fontWeight: "bold",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "1.25",
                      letterSpacing: "0.08px",
                      textAlign: "center",
                      color: "#ffffff",
                    }}
                  >
                  {loading ? <span style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}><Spinner animation="border" style={{ width: "25px", height: "25px" }} /></span> : "Sign up"}
                  </button>
                  
                  <hr style={{borderBottom:"0.1px solid lightgray",borderTop:"none",}} />
                  
                  <div style={{marginTop:"20px"}}>
                      <p 
                      style={{
                      width: "100%",
                      fontFamily: "OpenSans, Arial, sans-serif",
                      fontSize: "14px",
                      fontWeight: "normal",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      letterSpacing: "normal",
                      textAlign: "left",
                      color: "#535252",
                      }}   
                      >Already have an account? <button
                      type="button"
                      style={{
                      fontWeight: "600",
                      color: "#0f0f0f",
                      textDecoration: "underline",
                      border:"none",
                      padding:"0px",
                      backgroundColor:"white"
                      }}
                      onClick={openSignInModal} 
                      href="#">Log in</button></p>
                  </div>
                
                </div>
              </div>
            </div>
          </Modal.Body>
      </Modal>
    );
  }
}

export default TutorSignupModal;
